<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content modal-sm" style="background: white; opacity: 1.0; margin: 0 auto; border-radius: 8px;">
                    <div class="modal-body">
                        <div class="overlay">
                            <div class="loader"></div>
                            <h5 style="text-align: center; font-weight: bold; font-size: 18px;">{{this.textoModal}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        texto: String
    },
    data() {
        return {
            textoModal: ''
        }
    },
    created() {
        this.textoModal = this.texto;
    },
}
</script>

<style scoped>

.modal {
	display: block !important;
}

.loader {
	margin: 0 auto;
	transform: translate(-50%,-50%);
	width: 60px;
	height: 60px;
	border-radius: 50%;
	border: 4px solid #009ed2;
	border-right-color: transparent;
	transform-origin: center;
	animation: rotate 1s linear infinite;
}

@keyframes rotate {
	from {
	  transform: rotate(0);
	}
	to {
	  transform: rotate(360deg);
	}
}

</style>